import { createStore } from 'vuex'
import router from '@/router'
import { getMyUser, switchRole, getUserByPage } from '@/api/user'
import { getTeamMember, getTeamByPage } from '@/api/team'
import { getCompanyMember, getCompanyByPage } from '@/api/company'
import { getTaskType } from '@/api/task'
import { getAppConfig } from '@/api/config'
import { getRoleList } from '@/api/role'
import { getDataTypeList } from '@/api/dataType'
import { message } from 'ant-design-vue'
async function fetchUserInfo () {
  const res = await getMyUser()
  const userInfo = res.data.principal
  localStorage.setItem('westUserInfo', JSON.stringify(userInfo))
  localStorage.setItem('westNewLogin', '0')
  return userInfo
}
function compare (property) {
  return function (a, b) {
    var value1 = a[property]
    var value2 = b[property]
    return value1 - value2
  }
}
export default createStore({
  state: {
    appConfig: {}, // 全局配置
    userInfo: {}, // 用户基本信息
    optionalRoles: [],
    rolesVisible: false,
    currentRole: {},
    // 常用数据
    taskTypes: [],
    companyList: [],
    teamList: [],
    roleList: [],
    dataTypeList: [],
    userList: [],
    currentTask: {},
    // 数据集详情列表面包屑
    breadDatasetName: '',
    movingAttr: null, // 移动数据属性节点
    childrenId: []
  },
  mutations: {
    setAppConfig (state, info) {
      state.appConfig = info
    },
    setUserInfo (state, info) {
      state.userInfo = info
    },
    setOptionalRoles (state, info) {
      state.optionalRoles = info
    },
    setRolesVisible (state, boo) {
      state.rolesVisible = boo
    },
    setCurrentRole (state, info) {
      state.currentRole = info
    },
    handleLogout (state) {
      localStorage.removeItem('westToken')
      state.userInfo = {}
      state.optionalRoles = {}
      state.currentRole = {}
      window.location.href = '/auth/social/logout?redirect_uri=' + window.location.origin
      //router.push({ name: 'login' })
    },
    setTaskTypes (state, info) {
      state.taskTypes = info
    },
    setCompanyList (state, info) {
      state.companyList = info
    },
    setTeamList (state, info) {
      state.teamList = info
    },
    setRoleList (state, info) {
      state.roleList = info
    },
    setDataTypeList (state, info) {
      state.dataTypeList = info
    },
    setUserList (state, info) {
      state.userList = info
    },
    setCurrentTask (state, info) {
      state.currentTask = info
    },
    setBreadDatasetName (state, info) {
      state.breadDatasetName = info
    },
    setMovingAttr (state, data) {
      state.movingAttr = data
    },
    addChildrenId (state, arr) {
      state.childrenId.push(...arr)
    },
    clearChildrenId (state) {
      state.childrenId = []
    }
  },
  actions: {
    async getMyInfo ({ commit, state }) {
      let userInfo = {}
      if (localStorage.getItem('westNewLogin') === '1') {
        userInfo = await fetchUserInfo()
      } else {
        const str = localStorage.getItem('westUserInfo')
        try {
          userInfo = JSON.parse(str)
        } catch {
          userInfo = await fetchUserInfo()
        }
        if (!userInfo) {
          userInfo = await fetchUserInfo()
        }
      }
      commit('setUserInfo', userInfo)
    },
    async getOptionalRoles ({ commit, state }) {
      const userId = state.userInfo.userId
      const res = await getCompanyMember({ userId })
      const myComMembers = res.data.map.data.rows
      const optionalRoles = []
      myComMembers.forEach(m => {
        if (m.roleId === '7' || m.roleId === '13') {
          // 公司管理员角色
          const { roleId, companyId } = m
          optionalRoles.push({ roleId, companyId })
        }
      })
      const res2 = await getTeamMember({ userId })
      const myTeamMember = res2.data.map.data.rows
      for (const tm of myTeamMember) {
        const res = await getTeamByPage({ id: tm.teamId })
        const team = res.data.map.data.rows[0]
        tm.companyId = team ? team.companyId : ''
      }
      optionalRoles.push(...myTeamMember)
      if (myComMembers.length && optionalRoles.length) {
        commit('setOptionalRoles', optionalRoles)
        const existRole = localStorage.getItem('westCurrentRole')
        if (existRole) {
          const existRoleObj = JSON.parse(existRole)
          const { roleId, companyId, teamId } = existRoleObj
          if (optionalRoles.some(r => r.roleId === roleId && r.companyId === companyId && r.teamId === teamId)) {
            await switchRole({
              roleId,
              companyId,
              teamId
            }).then(() => {
              commit('setCurrentRole', existRoleObj)
            }).catch(e => {
              commit('setRolesVisible', true)
            })
          } else {
            commit('setRolesVisible', true)
          }
        } else {
          commit('setRolesVisible', true)
        }
      } else {
        // message.error('您的账号无有效角色，请联系管理员')
        // commit('handleLogout')
      }
    },
    async getFrequencyData ({ commit, state }) {
      await getAppConfig().then(res => {
        const data = res.data.map.data.rows[0]
        commit('setAppConfig', data)
        //document.title = data.commonTitle
        document.title = '数据平台-非结构化数据平台'
      })
      await getRoleList().then(res => {
        const data = res.data.data.rows.map(r => ({ ...r, roleId: r.roleId.toString() }))
        commit('setRoleList', data)
      })
      await getDataTypeList().then(res => {
        commit('setDataTypeList', res.data.map.data.rows)
      })
      await getCompanyByPage({
        pageNum: 1,
        pageSize: 10000
      }).then(res => {
        commit('setCompanyList', res.data.map.data.rows)
      })
      await getTeamByPage({
        pageNum: 1,
        pageSize: 10000
      }).then(res => {
        commit('setTeamList', res.data.map.data.rows)
      })
      await getTaskType().then(res => {
        localStorage.removeItem('taskTypes')
        const arr = res.data.map.data.rows.sort(compare('id')).slice(0, 8)
        localStorage.setItem('taskTypes', JSON.stringify(arr))
      })

      let westUserInfo = JSON.parse(window.localStorage.getItem('westUserInfo'))     
      if(westUserInfo.roleId){
        await getUserByPage({
          pageNum: 1,
          pageSize: 10000
        }).then(res => {
          commit('setUserList', res.data.data.rows)
        })
      }
      
    },
    updateTeamList ({ commit }) {
      getTeamByPage({
        pageNum: 1,
        pageSize: 10000
      }).then(res => {
        commit('setTeamList', res.data.map.data.rows)
      })
    }
  },
  modules: {
  }
})
